module.exports = __webpack_public_path__ + "img/sign_250810863_1.b5e9b281.png";